import React from 'react';
import './Merch.css';

// Merch items pulled from echohillband.bandcamp.com/merch
// Update this list manually when new items are added to Bandcamp
const MERCH_ITEMS = [
  {
    id: 1,
    title: 'Echo Hill Cassette',
    type: 'Cassette + Digital Album',
    price: '$12 USD',
    img: 'https://f4.bcbits.com/img/0044033825_10.jpg',
    url: 'https://echohillband.bandcamp.com/album/echo-hill',
    desc: 'The debut release on cassette. Includes a digital download card.',
  },
  {
    id: 2,
    title: 'Echo Hill Logo T-Shirt',
    type: 'Shirt',
    price: '$20 USD',
    img: 'https://f4.bcbits.com/img/0042924337_10.jpg',
    url: 'https://echohillband.bandcamp.com/merch/echo-hill-logo-t-shirt',
    desc: '',
  },
  {
    id: 3,
    title: 'Echo Hill Mountain Pin',
    type: 'Button / Pin / Patch',
    price: '$5 USD',
    img: 'https://f4.bcbits.com/img/0042924405_10.jpg',
    url: 'https://echohillband.bandcamp.com/merch/echo-hill-mountain-pin',
    desc: '',
  },
  {
    id: 4,
    title: 'Echo Hill Button',
    type: 'Button / Pin / Patch',
    price: '$2 USD',
    img: 'https://f4.bcbits.com/img/0042924401_10.jpg',
    url: 'https://echohillband.bandcamp.com/merch/echo-hill-button',
    desc: '',
  },
  {
    id: 5,
    title: 'Spaceman Sticker',
    type: 'Sticker',
    price: '$2 USD',
    img: 'https://f4.bcbits.com/img/0042924382_10.jpg',
    url: 'https://echohillband.bandcamp.com/merch/spaceman-sticker',
    desc: '',
  },
];

export default function Merch() {
  return (
    <div>
      <div className="section-container">
        <h1 className="section-title">Merch</h1>
        <div className="section-rule" />

        <div className="merch-header">
          <p className="merch-subtitle">Fulfilled via Bandcamp's secure checkout</p>
          <a
            href="https://echohillband.bandcamp.com/merch"
            target="_blank"
            rel="noopener noreferrer"
            className="merch-all-link"
          >
            View all on Bandcamp ↗
          </a>
        </div>

        <div className="merch-grid">
          {MERCH_ITEMS.map((item) => (
            <a
              key={item.id}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="merch-card"
            >
              <div className="merch-card-img">
                <img src={item.img} alt={item.title} />
              </div>
              <div className="merch-card-info">
                <p className="merch-card-type">{item.type}</p>
                <p className="merch-card-title">{item.title}</p>
                {item.desc && <p className="merch-card-desc">{item.desc}</p>}
                <p className="merch-card-price">{item.price}</p>
              </div>
              <div className="merch-card-cta">Buy on Bandcamp ↗</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
